import MainButton from '@/components/MainButton'
import TopLevelRules from './TopLevelRules'
import PointSystemRules from './PointSystemRules'
import ExampleScoring from './ExampleScoring.vue'
import Predictions from './Predictions.vue'
import GroupManagement from './GroupManagement.vue'

import SampleResults from '@/assets/sample-score.png'

export default {
  name: 'EngagementRules',
  components: {
    MainButton,
    TopLevelRules,
    PointSystemRules,
    ExampleScoring,
    Predictions,
    GroupManagement
  },
  data: () => ({
    currPage: 1,
    lastPage: 4,
    done: false,
    buttonLabel: 'Next',
    SampleResults
  }),
  methods: {
    triggerNext() {
      this.currPage++
      if (this.currPage === this.lastPage) {
        this.buttonLabel = 'Done'
      }
    },
    handleRoute() {
      switch (this.currPage) {
        case 1:
          this.triggerNext()
          break
        case 2:
          this.triggerNext()
          break
        case 3:
          this.triggerNext()
          break
        case 4:
          this.$router.push({ path: '/app/dashboard' })
          break
      }
    }
  },
  deactivated() {
    this.currPage = 1
    this.buttonLabel = 'Next'
  }
}
